module.exports = __webpack_public_path__ + "static/img/wpp3_4.cebc931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/wpp3_4.png
// module id = NIC0
// module chunks = 2